const Permission = [
  // {
  //   manager: 'sub_admin_manager',
  //   add: false,
  //   view: false,
  //   delete: false,
  //   shownView: true,
  //   shownEdit: true,
  //   shownDelete: true,
  //   shownAll: true
  // },
  {
    manager: "customers",
    add: false,
    view: false,
    delete: false,
    shownView: true,
    // shownEdit: true,
    shownEdit: false,
    shownDelete: false,
    shownAll: false,
  },
  {
    manager: "company_manager",
    add: false,
    view: false,
    delete: false,
    shownView: true,
    shownEdit: false,
    // shownEdit: true,
    shownDelete: false,
    shownAll: false,
  },
  {
    manager: "property_type_manager",
    add: false,
    view: false,
    delete: false,
    shownView: true,
    // shownEdit: true,
    shownEdit: false,
    shownDelete: false,
    shownAll: false,
  },
  {
    manager: "property_category_manager",
    add: false,
    view: false,
    delete: false,
    shownView: true,
    shownEdit: true,
    shownDelete: false,
    shownAll: false,
  },
  {
    manager: "amenities_manager",
    add: false,
    view: false,
    delete: false,
    shownView: true,
    shownEdit: true,
    shownDelete: false,
    shownAll: false,
  },
  {
    manager: "blog_manager",
    add: false,
    view: false,
    delete: false,
    shownView: true,
    shownEdit: true,
    shownDelete: false,
    shownAll: false,
  },
  {
    manager: "location_manager",
    add: false,
    view: false,
    delete: false,
    shownView: true,
    shownEdit: true,
    shownDelete: true,
    shownAll: false,
  },
  {
    manager: "subscription_manager",
    add: false,
    view: false,
    delete: false,
    shownView: true,
    shownEdit: true,
    shownDelete: false,
    shownAll: false,
  },
  {
    manager: "auction_manager",
    add: false,
    view: false,
    delete: false,
    shownView: true,
    shownEdit: true,
    shownDelete: false,
    shownAll: false,
  },
  {
    manager: "transaction_manager",
    add: false,
    view: false,
    delete: false,
    shownView: true,
    shownEdit: false,
    shownDelete: false,
    shownAll: false,
  },
  {
    manager: "notification_managers",
    add: false,
    view: false,
    delete: false,
    shownView: true,
    shownEdit: true,
    shownDelete: false,
    shownAll: false,
  },
  {
    manager: "marketing_material_manager",
    add: false,
    view: false,
    delete: false,
    shownView: true,
    shownEdit: true,
    shownDelete: false,
    shownAll: false,
  },
  {
    manager: "ads_and_banner_manager",
    add: false,
    view: false,
    delete: false,
    shownView: true,
    shownEdit: true,
    shownDelete: false,
    shownAll: false,
  },
  {
    manager: "reports_manager",
    add: false,
    view: false,
    delete: false,
    shownView: true,
    shownEdit: false,
    shownDelete: false,
    shownAll: false,
  },
  {
    manager: "property_manager",
    add: false,
    view: false,
    delete: false,
    shownView: true,
    shownEdit: true,
    shownDelete: true,
    shownAll: false,
  },
  {
    manager: "agent_manager",
    add: false,
    view: false,
    delete: false,
    shownView: true,
    shownEdit: true,
    shownDelete: false,
    shownAll: false,
  },
  {
    manager: "approval_manager",
    add: false,
    view: false,
    delete: false,
    shownView: true,
    shownEdit: true,
    shownDelete: false,
    shownAll: false,
  },
  {
    manager: "query_listing_manager",
    add: false,
    view: false,
    delete: false,
    shownView: true,
    shownEdit: false,
    shownDelete: true,
    shownAll: false,
  },
  {
    manager: "project_manager",
    add: false,
    view: false,
    delete: false,
    shownView: true,
    shownEdit: true,
    shownDelete: false,
    shownAll: false,
  },
  {
    manager: "careers",
    add: false,
    view: false,
    delete: false,
    shownView: true,
    shownEdit: true,
    shownDelete: false,
    shownAll: false,
  },
  {
    manager: "about_us",
    add: false,
    view: false,
    delete: false,
    shownView: true,
    shownEdit: true,
    shownDelete: false,
    shownAll: false,
  },
  {
    manager: "contact_us",
    add: false,
    view: false,
    delete: false,
    shownView: true,
    shownEdit: true,
    shownDelete: false,
    shownAll: false,
  },
  {
    manager: "faqs",
    add: false,
    view: false,
    delete: false,
    import: false,
    shownView: true,
    shownEdit: true,
    shownDelete: true,
    shownImport: true,
    shownAll: true,
  },
  {
    manager: "privacy_policy",
    add: false,
    view: false,
    delete: false,
    shownView: true,
    shownEdit: true,
    shownDelete: false,
    shownAll: false,
  },
  {
    manager: "terms_and_conditions",
    add: false,
    view: false,
    delete: false,
    shownView: true,
    shownEdit: true,
    shownDelete: false,
    shownAll: false,
  },
  {
    manager: "settings",
    add: false,
    view: false,
    delete: false,
    shownView: true,
    shownEdit: true,
    shownDelete: false,
    shownAll: false,
  },
  {
    manager: "unit_manager",
    add: false,
    view: false,
    delete: false,
    import: false,
    shownView: true,
    shownEdit: true,
    shownDelete: true,
    shownImport: true,
    shownAll: true,
  },
  {
    manager: "community_manager",
    add: false,
    view: false,
    delete: false,
    shownView: true,
    shownEdit: true,
    shownDelete: false,
    shownAll: false,
  },
  {
    manager: "project_status_manager",
    add: false,
    view: false,
    delete: false,
    shownView: true,
    shownEdit: true,
    shownDelete: false,
    shownAll: false,
  },
  {
    manager: "app_home_menu_manager",
    add: false,
    view: false,
    delete: false,
    shownView: true,
    shownEdit: true,
    shownDelete: false,
    shownAll: false,
  },
  {
    manager: "mortgageSettings",
    add: false,
    view: false,
    delete: false,
    shownView: true,
    // shownEdit: true,
    shownEdit: true,
    shownDelete: false,
    shownAll: false,
  },
  {
    manager: "units_report_manager",
    add: false,
    view: true,
    delete: false,
    shownView: true,
    shownEdit: false,
    shownDelete: false,
    shownAll: false,
  },
  {
    manager: "order_manager",
    add: false,
    view: true,
    delete: false,
    shownView: true,
    shownEdit: false,
    shownDelete: false,
    shownAll: false,
  },
  {
    manager: "order_discounts",
    add: false,
    view: true,
    delete: false,
    shownView: true,
    shownEdit: false,
    shownDelete: false,
    shownAll: false,
  },
  {
    manager: "test_manager",
    add: false,
    view: false,
    delete: false,
    shownView: true,
    shownEdit: true,
    shownDelete: true,
    shownAll: true,
  },
  {
    manager: "training_session_manager",
    add: false,
    view: false,
    delete: false,
    shownView: true,
    shownEdit: true,
    shownDelete: true,
    shownAll: true,
  },
];

export default Permission;
